import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'ag-grid-enterprise/dist/styles/ag-grid.css';
import 'ag-grid-enterprise/dist/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import { LicenseManager } from 'ag-grid-enterprise';
import './libs/i18n';
import AuthContextProvider from './context/UserContext';
import { getSiteWrapper } from './services';
LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-066400}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Digi-Key_Corporation}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Cross_Reference}_only_for_{3}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Cross_Reference}_need_to_be_licensed___{Cross_Reference}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{7_October_2025}____[v3]_[01]_MTc1OTc5MTYwMDAwMA==0ed61fdc8884eb870a6b9c915aec1f2c'
);
export const reactRenderFirstLoad = () =>{
  const promises: Promise<any>[] = [];
  promises.push(getSiteWrapper());
  Promise.all(promises).then((responses) => {
    ReactDOM.render(
      <AuthContextProvider>
        <App analytics={responses} />
      </AuthContextProvider>,
      document.getElementById('root')
    );
  });
}

window.onload = ()=>reactRenderFirstLoad()

//If you want to start measuring performance in your app, pass a function
//to log results (for example: reportWebVitals(console.log))
//or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
